import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { event } from "@zillow/universal-analytics";
import PropTypes from "prop-types";
import "react";
import { useForm, FormProvider } from "react-hook-form";
import { getCookieValue } from "../../utils/cookies/getCookieValue.esm.js";
import SimonScript from "../SimonScript/SimonScript.esm.js";
import { onError } from "./SimonForm.utils.esm.js";
const SimonForm = ({
  persona,
  storageEnvironment,
  subscriptionListName,
  treatmentName,
  children,
  id
}) => {
  const methods = useForm({
    mode: "onTouched"
  });
  const onSubmit = (data, e) => {
    const properties = {
      eventName: "CMS Simon Form",
      persona,
      subscriptionListName,
      treatmentName
    };
    Object.keys(data).forEach((key) => {
      if (key !== "email") {
        properties[key] = data[key];
      }
    });
    const userId = getCookieValue("zjs_user_id") !== null ? getCookieValue("zjs_user_id").replace(/[^A-Za-z0-9\-_]/g, "") : null;
    window.sd.identify(userId, {
      ...data.email && {
        email: data.email
      },
      properties
    });
    event({
      // https://dataportal.zillowgroup.net/event-registry/2055
      envelope: {
        event_type_id: "2055",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_button",
        trigger_object_nm: "no_trigger_object"
      },
      cms_info: {
        block_id: e.target.id || "",
        block_type_cd: "simon_data_form",
        form_submit_label: e.target.querySelector('[type="submit"]').textContent
      }
    });
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SimonScript, { storageEnvironment }),
    /* @__PURE__ */ jsx(FormProvider, { ...methods, children: /* @__PURE__ */ jsx("form", { onSubmit: methods.handleSubmit(onSubmit, onError), id, noValidate: true, children }) })
  ] });
};
SimonForm.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  persona: PropTypes.array,
  treatmentName: PropTypes.string,
  storageEnvironment: PropTypes.string.isRequired,
  subscriptionListName: PropTypes.string
};
export {
  SimonForm as default
};
